import React, { useId } from "react";
import PropTypes from "prop-types";

const PackOverview = ({ items, title = "Pack overview" }) => {
  const titleId = useId();
  return (
    <section aria-labelledby={titleId} className="wsm-pack-overview" id="pack-overview">
      <div className="wsm-pack-overview__heading">
        <h2 id={titleId}>{title}</h2>
        <p>Key planning and possession information for this worksite pack.</p>
      </div>
      <dl>
        {items.map((item) => (
          <div key={item.label}>
            <dt>{item.label}</dt>
            <dd>{item.value || <span className="wsm-pack-overview__empty">Not provided</span>}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
};

PackOverview.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.node })).isRequired,
  title: PropTypes.node,
};

export default PackOverview;
